// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"4b85ad7b","111":"5e31c9bc","175":"42c7be8e","423":"f859a4a1","732":"8320d7b5","820":"fc3e0365"}[chunkId] + ".css";
};